import {
	INSIGHT_CHARS_PER_SECOND,
	INSIGHT_THINKING_MS,
	surveyResponses,
} from '../../jsm-portal-playground-hr-data';
import { INSIGHT_SUMMARY_TEXT } from '../../jsm-portal-playground-hr-messages';
import { DEMO_CURSOR_TRAVEL_MS } from '../jsm-playground-demo-cursor';

export const SURVEY_DEMO_CURSOR_LABEL = 'Belle';

export const SURVEY_DEMO_RESPONSE_ID =
	surveyResponses.find((response) => response.answers)?.id ?? '';

const TRAVEL_MS = DEMO_CURSOR_TRAVEL_MS;
/** The cursor's own opacity fade. */
const FADE_MS = 400;
const PRESS_MS = 200;
/** A couple of frames, so a silent reposition paints before travel and the fade come back on. */
const TELEPORT_SETTLE_MS = 80;
/** The Insights card thinks, then types its summary out. */
const INSIGHT_LOAD_MS =
	INSIGHT_THINKING_MS + Math.ceil((INSIGHT_SUMMARY_TEXT.length / INSIGHT_CHARS_PER_SECOND) * 1000);
/** The last of the eight rows' 50ms-staggered, 260ms fades. */
const RESPONSES_LOAD_MS = 50 * (surveyResponses.length - 1) + 260;
const toggleArrive = 400 + TRAVEL_MS;
const togglePress = toggleArrive + 500;
const toggleRelease = togglePress + PRESS_MS;
// Time to see the table land before moving on.
const insightsMove = toggleRelease + 900;
const insightsPress = insightsMove + TRAVEL_MS + 500;
const insightsRelease = insightsPress + PRESS_MS;
// The answer gets a beat to be read before the cursor comes back.
const responsesJump = insightsRelease + INSIGHT_LOAD_MS + 1400;
const responsesIn = responsesJump + TELEPORT_SETTLE_MS;
const responsesPress = responsesIn + FADE_MS + 500;
const responsesRelease = responsesPress + PRESS_MS;
const firstRowJump = responsesRelease + RESPONSES_LOAD_MS + 500;
const firstRowIn = firstRowJump + TELEPORT_SETTLE_MS;
const firstRowPress = firstRowIn + FADE_MS + 600;
const firstRowRelease = firstRowPress + PRESS_MS;

/**
 * Belle's run through the survey: switch Question 1 to its table, open Insights and leave Rovo to
 * compose with the screen to itself, then reappear on the Responses tab, and finally on the first
 * response's action, which rises under the cursor as it fades in. The two returns are silent
 * repositions made while the cursor is invisible, so it is never seen travelling to them.
 */
export const SURVEY_DEMO = {
	cursorIn: 400,
	togglePress,
	toggleRelease,
	insightsMove,
	insightsPress,
	insightsRelease,
	insightsCursorOut: insightsRelease + 600,
	responsesJump,
	responsesIn,
	responsesPress,
	responsesRelease,
	responsesCursorOut: responsesRelease + 400,
	firstRowJump,
	firstRowIn,
	firstRowPress,
	firstRowRelease,
	cursorOut: firstRowRelease,
} as const;
